<template>
  <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  :width="width" :height="height" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"
  class="animate-spin" :style="{ '--anim-duration': `${duration}s` }">
    <path fill="currentColor" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
    </path>
  </svg>
</template>

<script>
export default {
  name: 'BaseLoadingSpinnerCircle',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    duration: {
      type: Number,
      default: 0.6
    }
  }
}
</script>

<style scoped>
.animate-spin {
  animation: spin var(--anim-duration) linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>